'use client';

export { default } from './AlertTitle';
export { default as alertTitleClasses } from './alertTitleClasses';
export * from './alertTitleClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/AlertTitle/index.js
// module id = 883
// module chunks = 25